<template>
  <div class="status" v-on="$listeners">
    <p class="text" :class="{ error: !status }">{{ text }}</p>
    <em v-if="status" class="icon-succ iconfont icon-dui"></em>
    <em v-else class="icon-fail iconfont icon-gantanhao"></em>
  </div>
</template>

<script>
export default {
  name: 'StatusItem',
  props: {
    text: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
.status {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100px;
  padding: 0 20px;
  background-color: var(--block-bg-light-color);
  border-radius: var(--border-radius);

  .text {
    flex: 1;
    font-size: 24px;

    &.error {
      color: var(--error-color);
    }
  }

  .icon-succ,
  .icon-fail {
    margin-left: 20px;
    font-size: 40px;
  }

  .icon-succ {
    color: var(--success-color);
  }

  .icon-fail {
    color: var(--error-color);
  }
}
</style>
